import { Input } from "@chakra-ui/react";
import { Field } from ".";
import { withMask } from "use-mask-input";
import { Mask } from "config";
import { useEffect, useState } from "react";

export default function Price({ onChange = () => {}, ...props }){

    const [ value, setValue ] = useState()
    
    useEffect(() => {
        onChange({ target: { name: props?.name, value }})
    }, [value]) 

    return(
    <Field {...props}>
        <Input onChange={e => setValue(Mask.price(e.target.value))} {...props} />
    </Field>
    )
}